<template lang="pug">
    .close-button
        .text(v-if="text" v-html="text")
        span
        span
</template>

<script>
    export default {
        name: "Closer",
        props: ['text'],
    }
</script>

<style scoped lang="scss">
    .close-button{
        position: relative;
        width: 2.5rem;
        min-height: 2.5rem;
        margin-bottom: 0.5vh;
        cursor: pointer;
        span{
            content: '';
            display: block;
            position: absolute;
            top: 50%;
            left: 0;
            right: 0;
            height: 2px;
            background: #fff;
        }
        span:nth-of-type(1){
            transform: translateY(-50%) rotate(45deg);
        }
        span:nth-of-type(2){
            transform: translateY(-50%) rotate(-45deg);
        }
        .text{
            position: absolute;
            right: 108%;
            top: 50%;
            transform: translateY(-50%);
            font-family: 'Fira Sans Extra Condensed', sans-serif;
            color: #fff;
            text-transform: uppercase;
        }
    }
    .mobile .close-button{
        top: 5.5vw;
        right: 4.5vw;
        width: 8vw;
        height: 8vw;
    }
</style>
